import * as TYPES from '../types';

const initialState = {
    isLoading: false,
};

export function LoadingReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {
        case TYPES.LOADING_START:
            return {
                ...preState,
                isLoading: true,
            };
        case TYPES.LOADING_END:
            return {
                ...preState,
                isLoading: false,
            };

        default:
            return state;
    }
}